import { ReactElement } from 'react';

import { useFormController } from '@dreryk/react-common';
import { Form } from '@dreryk/react-components';

import { ReviewRequestFormBean, ReviewRequestFormController } from './ReviewRequestForm.types';
import { ReviewRequestDecisionJustificationField } from './fields/ReviewRequestDecisionJustificationField';

type ReviewRequestFormChildrenRenderProps = Pick<ReviewRequestFormController, 'handleSubmit' | 'formState'>;

type ReviewRequestFormProps = {
   children: (renderProps: ReviewRequestFormChildrenRenderProps) => ReactElement;
};

export const ReviewRequestForm = (props: ReviewRequestFormProps): ReactElement => {
   const { register, handleSubmit, formState } = useFormController<ReviewRequestFormBean>({
      decisionJustification: null,
   });

   return (
      <Form noValidate autoComplete={false}>
         <ReviewRequestDecisionJustificationField register={register} />

         {props.children({
            handleSubmit: handleSubmit,
            formState: formState,
         })}
      </Form>
   );
};
